import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { StatisticsService } from '@app/services/Statistics/Statistics.service';
import { MenuItem } from 'primeng/api';
import { CSVDataService } from '@app/export/CSVDataService';
import { NavigationEnd, Router } from '@angular/router';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-presence-per-meeting',
  templateUrl: './presence-per-meeting.component.html'
})

export class PresencePerMeetingComponent implements OnInit {
  form;
  
  showSpinner = false;
  items: MenuItem[];
  response;
  years: any[] = [];
  constructor(
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private router: Router,
    private statisticsService: StatisticsService) {
    this.router.events.subscribe(x => {
      if (x instanceof NavigationEnd) {
        this.clearReport();
      }
    });
  }

  ngOnInit() {
    this.form = this.fb.group({
      lodges: ['', ''],
      camps: ['', ''],
      institutions: ['', ''],
      parentInstitutionId: ['', ''],
      selectedFilter: ['', ''],
      selectedYears: ['', ''],
      districts: ['', '']
    });
    this.setItems();
  }

  setItems() {
    this.items = [
      {
        label: 'Excel',
        icon: 'fa fa-file-excel',
        command: () => this.exportToCSV()
      }];
  }

  exportToCSV() {
    if (this.form.get('institutions').value.length === 0) {
      const firstrow = this.form.get('selectedFilter').value == 3 ? 'År;Nr;Institution;Antal närvarande;Antal medlemmar;Närvaro %' : 'År;Nr;Institution;Antal närvarande;Närvaro %';
      const datum = this.datePipe.transform(new Date(), 'yy-MM-dd');
      const filnamn = 'NärvaroPerMöte_' + datum;
      let data: any[] = [];
      this.response.forEach(x => {
        const row = {
          col1: x.year,
          col2: '',
          col3: '',
          col4: '',
          col5: ''
        }
        data.push(row);
        x.meetings.forEach(m => {
          const meetingrow = {
            col1: '',
            col2: m.sortOrder,
            col3: m.shortName + ' ' + m.name,
            col4: m.totalMembers,
            col5: m.attendancePercent
          };
          data.push(meetingrow);
        });
        const footer = {
          col1: 'Totalt:',
          col2: '',
          col3: '',
          col4: x.total.totalAmount,
          col5: x.total.totalPercent
        };
        data.push(footer);
        const emptyrow = {
          col1: '',
          col2: '',
          col3: '',
          col4: '',
          col5: ''
        };
        data.push(emptyrow);
      });
      CSVDataService.exportToCsv(filnamn + '.csv', data, firstrow);
    } else {
      const firstrow = this.form.get('selectedFilter').value == 3 ? 'År;Nr;Institution;Antal närvarande;Antal medlemmar;Närvaro %' : 'År;Nr;Institution;Antal närvarande;Närvaro %';
      const filnamn = 'OF_NärvaroPerMöte';
      let data: any[] = [];
      this.response.forEach(x => {
        const row = {
          col1: x.year,
          col2: '',
          col3: '',
          col4: '',
          col5: '',
          col6: ''
        };
        data.push(row);
        x.meetings.forEach(m => {
          const meetingrow = {
            col1: '',
            col2: m.month,
            col3: m.meetingDate,
            col4: m.memberAttendanceCount,
            col5: m.totalMembers,
            col6: m.attendancePercent
          }
          data.push(meetingrow);
        });
        const footer = {
          col1: 'Totalt:',
          col2: '',
          col3: '',
          col4: x.total.totalAmount,
          col5: '',
          col6: x.total.totalPercent
        };
        data.push(footer);
        const emptyrow = {
          col1: '',
          col2: '',
          col3: '',
          col4: '',
          col5: '',
          col6: ''
        }
        data.push(emptyrow);
      });
      CSVDataService.exportToCsv(filnamn + '.csv', data, firstrow);
    }
  }

  clearReport() {
    this.response = null;
    this.form?.reset();
    this.years = [];
  }

  createReport(evt) {
    this.showSpinner = true;
    this.response = [];
    const statisticsInput = {
      generalStatisticsReportInputModel: evt.value
    };
    this.statisticsService.GetAttendanceStatisticsPerMeetingReport(statisticsInput).subscribe((response: any) => {
      if (response) {
        this.response = response;
        this.years = [];
        this.response.forEach(x => {
          if (this.years.indexOf(x.year) === -1) {
            this.years.push(x.year);
          }
        });
        this.showSpinner = false;
      }
    });
  }

}
